/**
 * Bridges Clerk auth into the API client token getter.
 * Must be rendered inside <ClerkProvider>.
 */

import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../lib/api-client';

export function AuthBridge(): null {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenGetter(() => getToken());
  }, [getToken]);

  return null;
}
